{
  "confirm": "Bestätigen",
  "back": "Zurück",
  "error": {
    "generalError": "Etwas ist schiefgelaufen, bitte versuche es später nochmals oder kontaktiere uns."
  },
  "member": "ein Mitglied | {count} Mitglieder",
  "next": "Weiter",
  "roles": {
    "member": {
      "title": "Mitglied",
      "description": "Reguläre Mitglieder dieses Teams"
    },
    "coach": {
      "title": "Coach",
      "description": "Coaches für die Trainings dieses Teams"
    },
    "admin": {
      "title": "Admin",
      "description": "Benutzer mit administrativen Privilegien"
    }
  },
  "send": "Senden",
  "submit": "Abschicken",
  "you": "Du"
}
